export const footerText = "Kontrak Hukum © 2023 All Rights Reserved";
